import React from "react";

export const timelineFrameContentLabels = {
    DATE: 'Aika',
    DATE_FIMLAB: 'Ajanvaraus',
    LOCATION: 'Paikka',
    DETAILS: 'Tarkemmat tiedot',
    QUESTIONNAIRES: 'Kyselyt',
    INSTRUCTIONS: 'Ohjeet',
    CARE_UNIT_DETAILS: 'Tiedustelut',
    LAB_RESEARCH: 'Tutkimukset'
}
// "./src/views/timeline/components/TimelineItemWrapper.js.MUNP.careUnitDetails"
export const TimelineFrameContentLabelledWrapper = ({children, label, withHorizontalRule}) => {
    return (
        <div>
            <div className="row-fluid">
                <div className="span3">
                    <h3 style={{margin: "0", lineHeight: "20px", fontSize: "15px"}}>
                        {label}
                    </h3>
                </div>
                <div className="span9">
                    {children}
                </div>
            </div>
            {withHorizontalRule && <hr className="horizontal-rule" />}
        </div>

    );
}